<template>
  <styled-select
    class="campaign-select"
    :value="value"
    @input="val => $emit('input', val)"
    :size="2"
    returnValue
    :options="options"
    :disabled="disabled"
    placeholder="Select Campaign"
    ref="select"
  />
</template>

<script>
import StyledSelect from '@/components/common/dropDownList/StyledSelectVModel'

export default {
  components: {
    StyledSelect
  },
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionSet: {
      type: Array,
      default: null
    }
  },
  computed: {
    options () {
      let optionValues = [{Name: 'Create New Campaign', value: 'newCampaign'}]
      if (this.optionSet) {
        this.optionSet.forEach(campaign => {
          if (campaign) {
            optionValues.push({Name: campaign.campaignName, value: campaign.campaignId})
          }
        })
      }
      return optionValues
    },
  },
  methods: {
    clear () {
      this.$refs.select.clear()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// CampaignDDL.vue?62824c0a